import React from 'react';

const Footer = () => (
    <div className="footer">
        <a className="footer-link" href="https://edu-sense.com/pl/produkty">
            <img src="/akademia/image/sklep.svg"
                className="footer-icon" alt="Akademia UDP" />
                <span className="link-text">Sklep</span>
        </a>
        <a className="footer-link" href="https://akademia.uczymydzieciprogramowac.pl">
            <img src="/akademia/image/logo_menu_udp.png"
                className="d-inline-block align-top img-fluid p-2 logo-image" alt="Akademia UDP" />
        </a>
        <div className="footer-link">
            <img src="/akademia/image/kodowanie_na_dywanie_logo.svg"
                className="d-inline-block align-top img-fluid p-2 logo-image" alt="Kodowanie na dywanie" />
        </div>
    </div>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/Footer/index.js